import React, { Component } from "react";
import { TaskTagButtonsLayout, FilterCheckBox, AddNewButtonLayout } from "../../common/Global/globalStyles.style";
import { BrowserRouter as Router } from "react-router-dom";
import * as Constants from "../../common/Global/constants";
import {
	getLocalStorageVariables,
	isEmptyVariable,
	getThemeSettingsVariables,
	isEmptyArray,
	removeHtmlTags,
	isJsonString,
	handleTokenExpiry,
} from "../../common/Global/commonFunctions";
import "react-quill/dist/quill.snow.css";
import ShowObsDetailsAnnexureDialog from "./showAnnexure";
import * as TemplateConstants from "../../common/Global/templateConstants";
import moment from "moment";

let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();
//if the status is draft or created then there will be auto save other wise no...
const emptyString = "-";

class ObservationDetails extends Component {
	constructor(props) {
		super(props);

		this.state = {
			businessRisk: [],
			valueAdditions: [],
			deptDefaultRisk: {},
			// userDefinedFieldsObj: {},
			selectedDepartmentId: "",
			assignmentStatus: "",
			datalist:[],
            datalistLeft:[],
			formCustomRisk:"",

			showLoader: false,
			componentDidMountFlag: false,

			showAlertWithInputDialog: false,
			// rows: 0,
			// cols: 0,

			// formCustomRisk: "",
			// formCustomRisk_NR: "",
			// formCustomRisk_isFocused: false,
			// suggestion: "",
			// suggestion_isFocused: false,
			// suggestion_NR: "",

			// selectedRiskImpactName: riskImpactDropdownDefaultValue,
			// selectedRiskImpactId: "",
			// selectedRiskIdArr: [],
            // selectedRiskDispName: [],


			//TAGS
			//Tag tasks
			showSelectTagTasksDialog: false,
			//Risk
			showSelectRiskDialog: false,
			selectedRiskObj: {},
			//Value Addition
			showSelectVADialog: false,
			selectedVAObj: [],
			//Upload annexure
			showSelectUploadAnnexureDialog: false,
			uploadedAnnexureArr: [],
			uploadedBackupArr: [],
			annexure_NR:"",
			//Upload Backup
			showSelectUploadBackupDialog: false,
			selectedUploadBackupObj: [],
			backup_NR:"",

			// formErrors: {},
		};
		userDetails = getLocalStorageVariables();
		themeSettings = getThemeSettingsVariables();
	}

	componentDidMount() {
		this.initData();
	}

	/************* DIALOGS***************/
	//Tag Tasks
	handleSelectTagTasksDialogClose = () => {
		this.setState({
			showSelectTagTasksDialog: false,
		});
	};
	
	handleSelectTagTasksDialogShow = () => {
		this.setState({
			showSelectTagTasksDialog: true,
		});
	};

	// Value addition
	handleSelectVADialogClose = () => {
		this.setState({
			showSelectVADialog: false,
		});
	};
	
	handleSelectVADialogShow = () => {
		this.setState({
			showSelectVADialog: true,
		});
	};

	// Upload annexure
	handleSelectUploadAnnexureDialogClose = () => {
		this.setState({
			showSelectUploadAnnexureDialog: false
		});
	};
	
	handleSelectUploadAnnexureDialogShow = () => {
		console.log(":::show annexure dialog");
		this.setState({
			showSelectUploadAnnexureDialog: true
		});
	};

	// Upload backup
	handleSelectUploadBackupDialogClose = () => {
		this.setState({
			showSelectUploadBackupDialog: false
		});
	};
	
	handleSelectUploadBackupDialogShow = () => {
		this.setState({
			showSelectUploadBackupDialog: true
		});
	};

	/************* DIALOGS END HERE***************/

	/************************API CALLS****************************/
	initData = () => {
		this.setState({
			showLoader: true,
		});

		Promise.all([
			fetch(Constants.GetAuditeeEmployeeDraftReports + "/"+this.props.assignmentId+"/observations/"+this.props.observationId, {
				method: "POST",
				mode: "cors",
				body: new URLSearchParams({
					email: userDetails.email,
					accessToken: userDetails.accessToken
				}),
			}),
			
		])
		.then(([obsservationRes]) => {
			return Promise.all([obsservationRes.json()]);
		})
		.then(([obsservationRes]) => {
			let businessRiskArr = [];

			let deptDefaultRisk = [];
			let valueAdditions = [];
			let assignedDeptId = "";
			let assignmentStatus = "";
			let observationDetails = {};
			let observationTasks = [];
			let observationVAArr = [];
			let observationAnnexures = [];
			let observationBackups = [];
			// let userDefinedFieldsObj = {};
			let riskObj = {};
			let likelihoodObj = {};
			let datalistTemp = [];
			let datalistLeftTemp = [];
			let datalist = [];
			let datalistLeft = [];
			let templateFieldValueList = {};
			let templateFieldValuesMap = {};
			let formCustomRisk = "";
			let observationTemplateFixedFields = {};
				
			if(handleTokenExpiry(obsservationRes.responseCode)) return;
			else if (obsservationRes.responseCode === Constants.CODE_SUCCESS) {
				observationDetails = obsservationRes.data.observationDetails;

				riskObj = {
					riskLevelId:observationDetails.riskLevelId,
					riskLevel:observationDetails.riskLevel
				}
				likelihoodObj = {
					likelihoodLevelId: observationDetails.likelihoodLevelId,
					likelihoodLevel: observationDetails.likelihoodLevel
				}
				if(!isEmptyVariable(obsservationRes?.data?.templateFields) && isJsonString(obsservationRes?.data?.templateFields)){
					datalistTemp = JSON.parse(obsservationRes.data.templateFields);
				}
				if(!isEmptyVariable(obsservationRes?.data?.templateFieldsLeft) && isJsonString(obsservationRes?.data?.templateFieldsLeft)){
					datalistLeftTemp = JSON.parse(obsservationRes.data.templateFieldsLeft);
				}
				let fixedTemplateFields = obsservationRes.data.fixedTemplateFields;
				if (
					!isEmptyVariable(fixedTemplateFields) &&
					isJsonString(fixedTemplateFields)
				) {
					observationTemplateFixedFields = JSON.parse(fixedTemplateFields);
				}
				// observationTasks = obsservationRes.data.observationTasks;
				observationVAArr = obsservationRes.data.valueAdditionList;
				observationAnnexures = obsservationRes.data.annexureList;
				observationBackups = obsservationRes.data.backupList;
				templateFieldValueList = obsservationRes.data.templateFieldValueList;
					
				templateFieldValueList.forEach(item=>{
					templateFieldValuesMap[JSON.stringify(item.fieldId)] = item;
				});
				//Add fieldValue and isNRChecked from ValuesMap to datalist
				datalist = datalistTemp.map(item=>{
					if(item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI ||
						item.fieldType === TemplateConstants.FIELD_TYPE_TABLE ){
						if(!isEmptyVariable(templateFieldValuesMap[item.fieldId]?.value) &&
							templateFieldValuesMap[item.fieldId]?.valueNR !== "Y" &&
							isJsonString(templateFieldValuesMap[item.fieldId]?.value)
						){
							item.fieldValue = JSON.parse(templateFieldValuesMap[item.fieldId]?.value);
							if(item.fieldType === TemplateConstants.FIELD_TYPE_TABLE){
								item.isTableAdded = true;
							}
							
						}else{
							item.fieldValue = [];
						}
					}else{
						if(templateFieldValuesMap[item.fieldId]?.valueNR !== "Y"){
							item.fieldValue = templateFieldValuesMap[item.fieldId]?.value;
						}
					}

					item.isNRChecked = templateFieldValuesMap[item.fieldId]?.valueNR;
					return item;
				});
				datalistLeft = datalistLeftTemp.map(item=>{
					if(item.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT){
						if(!isEmptyVariable(templateFieldValuesMap[item.fieldId]?.value) &&
							templateFieldValuesMap[item.fieldId]?.valueNR !== "Y"
						){
							item.fieldValue = JSON.parse(templateFieldValuesMap[item.fieldId]?.value);
						}else{
							item.fieldValue = [];
						}
					}else{
						if(templateFieldValuesMap[item.fieldId]?.valueNR !== "Y"){
							item.fieldValue = templateFieldValuesMap[item.fieldId]?.value;
						}
					}
					item.isNRChecked = templateFieldValuesMap[item.fieldId]?.valueNR;
					return item;
				});

			} else {
			}


			this.setState({
				showLoader: false,
				componentDidMountFlag: true,
				deptDefaultRisk: deptDefaultRisk,
				businessRisk: businessRiskArr,
				valueAdditions: valueAdditions,
				// userDefinedFieldsObj: userDefinedFieldsObj,
				selectedDepartmentId: assignedDeptId,
				assignmentStatus: assignmentStatus,
				 formCustomRisk:formCustomRisk,
				selectedRiskObj:riskObj,
				likelihoodObj:likelihoodObj,
				selectedRiskId: observationDetails.riskLevelId,
				selectedVAObj: observationVAArr.map((item) => {
					return {
						valueAdditionId: item.valueAdditionId,
						valueAdditionValue: item.valueAdditionValue,
						valueAddition_NR: item.valueAddition_NR,
					};
				}),
				uploadedAnnexureArr: observationAnnexures.map((item) => {
					return {
						fileName: item.documentPath,
						remark: item.remark,
					};
				}),
				annexure_NR:observationDetails.annexure_NR,
				backup_NR:observationDetails.backup_NR,
				uploadedBackupArr: observationBackups.map((item) => {
					return {
						fileName: item.documentPath,
						remark: item.remark,
					};
				}),
                datalist: datalist,
				datalistLeft: datalistLeft,
				templateFieldValuesMap:templateFieldValuesMap,
				observationTemplateFixedFields:observationTemplateFixedFields
			});
		});
	};

	render() {
		return (
			<Router>
				{this.state.componentDidMountFlag && (
					<div className="m-t-10">
						{this.state.showLoader && (
							<div class="loader"></div>
						)}
						<div className="prev-next-layout">
							<div className="flex-center-layout secondary-top-bar">
								<div className="back-btn-layout" onClick={this.props.handleHideObsDetailsLayout}>
									<span class="material-icons-outlined">arrow_back_ios</span>
								</div>
								<h6>{"Observation Details"}</h6>
							</div>
                            {
                                this.props.allowEdit &&
                                <AddNewButtonLayout themeSettings={themeSettings}>
                                    <a href={this.props.editUrl}>
                                        <span className="material-icons">edit</span>
                                        <p>Edit</p>
                                    </a>
                                </AddNewButtonLayout>
                            }
						</div>

						<div className="m-t-10">
							<div className="row custom-row">
								<div className="col-md-3 custom-col">
									<TaskTagButtonsLayout themeSettings={themeSettings}>
										<ul>
											<li>
												<a href={Constants.URL_OBSERVATIONLIST + "/" + this.props.assignmentId}>Back</a>
											</li>
											<li>
												<div className="row">
													<div className={"col-6 pr-1"}>
														<div className="tagLayout h-100">
															<div className="tagHeadingLayout">
																<p>Risk</p>
																{
																	!isEmptyVariable(this.state.selectedRiskObj.riskLevelId) &&
																	<span class="material-icons">check_circle</span>
																}
															</div>
															{
																isEmptyVariable(this.state.selectedRiskObj.riskLevelId)
																?
																<p>{emptyString}</p>
																:
																<p>{this.state.selectedRiskObj.riskLevel}</p>
															}
														</div>
													</div>
													<div className="col-6 pl-1">
														<div className="tagLayout h-100">
															<div className="tagHeadingLayout">
																<p>Likelihood</p>
																{
																	!isEmptyVariable(this.state.likelihoodObj.likelihoodLevelId) &&
																	<span class="material-icons">check_circle</span>
																}
															</div>
															{
																isEmptyVariable(this.state.likelihoodObj.likelihoodLevelId)
																?
																<p>{emptyString}</p>
																:
																<p>{this.state.likelihoodObj.likelihoodLevel}</p>
															}
														</div>
													</div>
												</div>
											</li>
											{this.state.observationTemplateFixedFields?.annexures === "Y" &&
												<li>
													<div className="tagLayout">
														<div className="tagHeadingLayout">
															<p>Annexures</p>
																{
																	(!isEmptyArray(this.state.uploadedAnnexureArr) || this.state.annexure_NR === "Y" ) && 
																	<span class="material-icons">check_circle</span>
																}
														</div>
														{
															(isEmptyArray(this.state.uploadedAnnexureArr) && this.state.annexure_NR !== "Y" )
															?
															<p>{emptyString}</p>
															:
															<div>
																<button onClick={this.handleSelectUploadAnnexureDialogShow}>View Details</button>
															</div>
														}
													</div>
													
												</li>
											}
											{
												this.state.datalistLeft.map((item,index)=>{
													if(item.fieldType === TemplateConstants.FIELD_TYPE_SINGLE_SELECT){
														return  <li>
															<div className="tagLayout">
																<div className="tagHeadingLayout">
																	<p>{item.fieldName}</p>
																	{
																		!isEmptyVariable(item.fieldValue) &&
																		<span class="material-icons">check_circle</span>
																	}
																</div>
																{
																	isEmptyVariable(item.fieldValue)
																	?
																	<p>{emptyString}</p>
																	:
																	<p>{item.fieldValue}</p>
																}
															</div>
														</li>

													}else if(item.fieldType === TemplateConstants.FIELD_TYPE_MULTI_SELECT){
														return  <li>
															<div className="tagLayout">
																<div className="tagHeadingLayout">
																	<p>{item.fieldName}</p>
																	{
																		!isEmptyArray(item.fieldValue) &&
																		<span class="material-icons">check_circle</span>
																	}
																	
																</div>
																{
																	isEmptyArray(item.fieldValue)
																	?
																	<p>{emptyString}</p>
																	:
																	<p>{item.fieldValue.join(", ")}</p>
																}
															</div>
														</li>

													}
												})
											}
										</ul>
									</TaskTagButtonsLayout>
								</div>
								
								<div className="col-md-9 custom-col">
								{
									this.state.datalist.map((item,index)=>{
                                        let showHeader = true;
                                        if(item.fieldType===TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI){
                                            if(item.isFromRiskMaster){
                                                if(item.isRiskMasterEnabled === "Y"){
                                                    showHeader = true;
                                                }else{
                                                    showHeader = false;
                                                }
                                            }else{
                                                showHeader = true;
                                            }
                                        }
										return (
										<div class="editor-card">
                                            {
                                                showHeader &&
                                                <div className={item.isNotReqSelected === "Y"?"task-header-layout editor-border-bottom m-b-0":"task-header-layout editor-border-bottom"}>
                                                    <h6 className="editor-heading">
                                                    {item.fieldName}{item.isMandatorySelected === "Y"?"*":""}
                                                    </h6>
                                                    {
                                                        item.isNotReqSelected === "Y"
                                                        ?
                                                            <FilterCheckBox themeSettings={themeSettings}
                                                            style={{marginLeft:0}}>
                                                                <input 
                                                                    type="checkbox"
                                                                    name={item.fieldName+":-:"+index}
                                                                    id={item.fieldName+":-:"+index}
                                                                    onChange={this.handleCheck}
                                                                    disabled={true}
                                                                    checked={item.isNRChecked === "Y"?true:false}
                                                                />
                                                                <label for={item.fieldName+":-:"+index}>Not Required</label>
                                                            </FilterCheckBox>
                                                        :
                                                            <div />
                                                    }
                                                </div>
                                            }
											{
												(item.fieldType === TemplateConstants.FIELD_TYPE_TEXT  ||
												item.fieldType === TemplateConstants.FIELD_TYPE_NUMERIC ||
												item.fieldType === TemplateConstants.FIELD_TYPE_VALUE_ADDITION) &&
												<div class="row custom-row">
													<div class="col-md-12 custom-col">
														{
															item.isNRChecked !== "Y" &&
															<div class="editor-text-layout">
																{
																	isEmptyVariable((item.fieldValue))
																	?
																	<p>{emptyString}</p>
																	:
																		(isEmptyVariable(removeHtmlTags(item.fieldValue))
																		?<p>{emptyString}</p>
																		:
																		<div dangerouslySetInnerHTML={{__html: item.fieldValue}} />)
																}
																
															</div>
														}
													</div>
												</div>
											}
											{
												item.fieldType === TemplateConstants.FIELD_TYPE_DATE &&
												<div class="row custom-row">
													<div class="col-md-12 custom-col">
														{
															item.isNRChecked !== "Y" &&
															<div class="editor-text-layout">
																{
																	isEmptyVariable((item.fieldValue))
																	?
																	<p>{emptyString}</p>
																	:
																	<p>{moment(item.fieldValue).format("DD/MM/YYYY")}</p>
																}
																
															</div>
														}
													</div>
												</div>
											}
											{
												item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI &&
                                                item.isRiskMasterEnabled === "Y" &&
												item.isFromRiskMaster &&
												<div class="row custom-row">
													<div class="col-md-12 custom-col">
														<div class={item.isNRChecked === "Y"?"editor-disabled":""}>
														{
															isEmptyArray(item.fieldValue)?
															<p className="m-b-0">-</p>
															:
															(
															<ul style={{marginBottom:5,paddingLeft:25}}>
																{
																	this.state.businessRisk.map(riskItem=>{
																		if(item.fieldValue.includes(riskItem.businessRiskId)){

																			return(
																				<li className="m-b-0 font-size-p">{riskItem.displayName}</li>
																			)
																		}
																	})  
																}
															</ul>)
														}
														{
															item.fieldValue.some(fieldItem => fieldItem === -1)  &&
															<div class="editor-text-layout">
																<div style={{marginLeft:25}}
																dangerouslySetInnerHTML={{__html: this.state.formCustomRisk}} />
															</div>
														}

														</div>
													</div>
												</div>
											}
											{
												item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN_MULTI &&
												!item.isFromRiskMaster &&
												<div class="row custom-row">
													<div class="col-md-12 custom-col">
														<div class={item.isNRChecked === "Y"?"editor-disabled":""}>
														{
															isEmptyArray(item.fieldValue)?
															<p className="m-b-0">-</p>
															:
															(
															<ul style={{marginBottom:5,paddingLeft:25}}>
																{
																	item.fieldValue.map(valueItem=>{

																		return(
																			<li className="m-b-0 font-size-p">{valueItem}</li>
																		)
																	})  
																}
															</ul>)
														}
														</div>
													</div>
												</div>
											}
											
											{
												item.fieldType === TemplateConstants.FIELD_TYPE_DROPDOWN &&
												<div class="row custom-row">
													<div class="col-md-12 custom-col">
                                                        <div class="editor-text-layout">
														{
															isEmptyVariable(item.fieldValue)?
															<p className="m-b-0">-</p>
															:
															<p>{item.fieldValue}</p>
														}
														</div>
													</div>
												</div>
											}

											{
												item.fieldType === TemplateConstants.FIELD_TYPE_TABLE &&
												<div className="flex-center-layout" style={{justifyContent:"center"}}>
													{
														!item.isTableAdded &&
														<p>{emptyString}</p> 
													}
													{
														item.isTableAdded &&
														<div
															style={{ width: "100%", marginTop: 10, boxShadow: "none" }}
															class={
																item.isNRChecked === "Y"
																	? "editor-layout editor-disabled common-table"
																	: "common-table editor-layout"
															}
														>
													
															<table class="table instances-table">
																
																{
																	item.fieldValue.map((rowItem, rowIndex) =>  {
																		if(rowIndex === 0){
																			return <thead className="instances-thead">
																				<tr>
																				{
																					rowItem.map((colItem, colIndex) => {
																						if(colIndex !== rowItem.length-1){

																							return <th className="text-center">
																								<div className="instances-table-header">
																									<p>
																										{colItem}
																									</p>
																								</div>
																							</th>
																						}
																					})
																				}
																				</tr>
																				</thead>
																				
																		}else{
																			return <tbody className="instances-thead">
																				<tr>
																				{
																					rowItem.map((colItem, colIndex) => {
																						if(colIndex !== rowItem.length-1){

																							return <td className="text-center">
																								{colItem}
																							</td>
																						}
																					})
																				}
																				</tr>
																			</tbody>

																		}

																	})
																}
															</table>
														</div>
													}
												</div>
											}
											
										</div>
										)
									})
								}
								
							</div>
							</div>
							<div className="row custom-row">
								<div className="col-md-12 custom-col">
									<div className="common-close-save">
										<div className="common-close-save-col">
											<button onClick={this.props.handleHideObsDetailsLayout} type="button" className="common-close">
												Close
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>

						<ShowObsDetailsAnnexureDialog
							showUploadAnnexureDialog={this.state.showSelectUploadAnnexureDialog}
							handleSelectUploadAnnexureDialogClose={this.handleSelectUploadAnnexureDialogClose}
							uploadedAnnexureArr={this.state.uploadedAnnexureArr}
							themeSettings={themeSettings}
							annexure_NR={this.state.annexure_NR}
						/>
						{/* <ShowObsDetailsBackupDialog
							showUploadBackupDialog={this.state.showSelectUploadBackupDialog}
							handleSelectUploadBackupDialogClose={this.handleSelectUploadBackupDialogClose}
							uploadedBackupArr={this.state.uploadedBackupArr}
							themeSettings={themeSettings}
							backup_NR={this.state.backup_NR}
						/> */}
						
					</div>
				)}
			</Router>
		);
	}
}
export default ObservationDetails;
